import type {MemexChartConfiguration} from '../../api/charts/contracts/api'
import {useChartSeriesQuery} from '../../queries/use-chart-series-query'

export function useHistoricalChartSeriesChartCard({
  configuration,
  startDate,
  endDate,
}: {
  configuration: MemexChartConfiguration
  startDate?: string
  endDate?: string
}) {
  const {filter, xAxis, yAxis, time} = configuration
  const chartQuery = useChartSeriesQuery({filter, xAxis, yAxis, startDate, endDate, period: time?.period})
  const isLoading = !chartQuery.data
  const series = chartQuery.data?.dataSeries || []
  const xCoordinates = chartQuery.data?.xAxis.values || []
  return {
    series,
    xCoordinates,
    isLoading,
  }
}
